<template>
  <div class="container">
    <Header></Header>
    <Banners :banner="banner"></Banners>
    <Introduce :Introduce="construction_situation"></Introduce>
    <CooperationUnit></CooperationUnit>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/components/Header"
  import Footer from "@/components/Footer"
  import Banners from "@/components/Banners"
  import Introduce from "@/components/Big_Data/Introduce"
  import CooperationUnit from "@/components/Big_Data/CooperationUnit"

  export default {
    name: 'Big_Data',
    data() {
      return {
        banner: require("@/assets/imgs/bg-banner-bigdata.png"),
        construction_situation: {
          title: "大数据平台建设情况",
          contents: ["苏州瑞鹏信息技术有限公司已经构建符合自己特色的用户标签体系，建立<span style='font-size: 60px;color:#4196FF;margin: 0 5px;'>17+</span>维表；11大类超过<span style='font-size: 60px;color:#FB6604;margin: 0 8px;'>106</span>个标签与模型，拥有并基于spark大数据生态组建作为核心处理技术，对海量数据进行规整处理，刻画出用户画像体系，并不断迭代、丰富受众标签描述。在此基础上利用业务的正、负样本数据，使用TGI(Target Group Index)对受众行为偏好进行计算，找寻出最优质最符合条件的受众，为运营提供精准营销服务，实现千人千面的营销策略。",
          ],
          class: "FFFFFF"
        },
      }
    },
    components: {
      Header, Banners,Footer,Introduce,CooperationUnit
    },
    created() {
      this.$store.commit('changeNavs', 'Big_Data')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    min-width: 1350px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Big_Data.vue